@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.store-status-error-modal {
  /* Match marketplace connection modal exactly */
  @media @tablet, @desktop, @widescreen, @ultrawide {
    height: 600px;
    width: 750px;
  }

  @media @mobile {
    height: calc(100vh - 50px);
  }
}

.store-status-error-modal-body {
  height: 100%;
  overflow: hidden;
  padding: @space-24;
  display: flex;
  flex-direction: column;

  @media @mobile {
    height: calc(100vh - 50px);
  }

  .store-error-content {
    .store-header {
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--grey--100);
      border-bottom: 1px solid var(--grey--300);
    }

    .marketplace-logo {
      display: flex;
      width: 36px;
      height: 36px;
      padding: 4.5px 6px;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1/1;
    }

    .store-name {
      color: #45505b;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .error-details-container {
      border-radius: 8px;
      border: 1px solid #dfe4e8;
      padding: @space-16;
      margin-top: @space-16;

      .error-details-chevron {
        width: 12px;
        float: right;
        cursor: pointer;
        color: #637381;
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        font: inherit;
      }

      .error-status-code {
        color: #212c36;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }

      .error-description {
        margin-top: @space-16;
        color: #27292a;
        font-family: Figtree;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      .copy-button-container {
        display: flex;
        margin-top: 16px;
        margin-bottom: 5px;
        height: 12px;
        align-items: center;

        * {
          color: #45505b !important;
        }

        button {
          color: #45505b !important;
        }

        svg {
          color: #45505b !important;
          fill: #45505b !important;
        }
      }
    }
  }

  .error-metadata {
    color: #45505b;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .error-date {
    margin-right: @space-4;
  }

  .troubleshooting-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    margin-top: @space-16;
  }

  .troubleshooting-title {
    color: #212c36;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .troubleshooting-steps {
    margin-top: 6px;
    li {
      color: #212c36;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      margin-bottom: @space-8;
    }
  }
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-16 @space-24;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: var(--size-xxl);

  .footer-left {
    display: flex;
    align-items: center;
  }

  .footer-right {
    display: flex;
    gap: @space-12;
    align-items: center;
  }

  .contact-support-link {
    background: none;
    border: none;
    color: #1d5ad8;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .get-help-button {
    color: #0f0f10;
    display: flex;
    width: 90px;
    padding: 0 8px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #afb3b6;
    background: #fff;
  }

  .reconfig-store-button {
    margin-left: 5px !important;
  }

  .new-window-icon {
    width: 11px;
    color: #11003a;
    opacity: 0.7;
    margin-left: 6px;
  }
}
